/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import {message} from 'antd'

import $ from 'jquery'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import FromToPicker from '../BaseComponent/FromToPicker'
import SortTable from '../BaseComponent/SortTable'
import RETAIL from '../BaseComponent/RETAIL'

class SpeedDriver extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      total: '',
      printInfo: [],
      grouping: '',
      aggregation: {},
      buttonClicked: false,
      providers: [],
      providerIdObject: [],
      providerIds: [],
      warehouses: [],
      warehousesObjects: [],
      warehouseIds: [],
      fromRegDate: '',
      toRegDate: '',

      sortData: [
        {name: 'ردیف', value: 'id', sorted: false, direction: null, sortable: false},
        {name: 'نام', value: 'firstName', sorted: false, direction: null, sortable: false},
        {name: 'بیشترین سرعت', value: 'maxSpeed', sorted: false, direction: null, sortable: false},
        {name: 'میانگین سرعت', value: 'avgSpeed', sorted: false, direction: null, sortable: false},
        {name: 'مشاهده روی نقشه', value: 'avgSpeed', sorted: false, direction: null, sortable: false}
      ],
      sortResult: 'sortBy='
    }
  }
  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  handleChangeFromRegDate = (fromRegDate) => {
    this.setState({
      fromRegDate
    })
  }

  handleChangeToRegDate = (toRegDate) => {
    this.setState({
      toRegDate
    })
  }

  filter() {
    let from = this.state.fromRegDate
    let to = this.state.toRegDate
    let speedMin = document.getElementById('speedMin').value
    let speedMax = document.getElementById('speedMax').value

    if (from === '' || to === '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((from != '' || from == null) && isNaN(from)) {
      message.error('فرمت تاریخ ثبت ابتدا صحیح نیست')
    } else if ((to != '' || to == null) && isNaN(to)) {
      message.error('فرمت تاریخ ثبت انتها صحیح نیست')
    } else {
      let data = {
        from,
        to,
        speedMax: Number(speedMax),
        speedMin: Number(speedMin)
      }
      http.post(`${RETAIL.RETAIL_MANAGE_SPEED_DRIVER_RANGE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            list: response.data.object,
            buttonClicked: true,
            fromDate: from,
            toDate: to
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          // message.error(response.data.description)
        }
      })
    }
  }

  quantity() {
    let quantitymin = Number(document.getElementById('speedMin').value)
    // let quantitymax=Number(document.getElementById('quantitymax').value);
    document.getElementById('speedMax').value = quantitymin + 1
    let quantitymax = document.getElementById('speedMax').value
  }

  render() {
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')

    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>رساننده ها</li>
            <li>سرعت رساننده ها</li>
          </ul>
          <div className="tableComponent">
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromRegDate}
                  onChangeToDate={this.handleChangeToRegDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue
                  fromId="fromReg"
                  toId="toReg"
                  force
                />
                <div className="formComponent">
                  <label>سرعت از :‌</label>
                  <input
                    type="number"
                    onChange={this.quantity.bind(this)}
                    min={0}
                    className="form-control"
                    id="speedMin"
                  />
                </div>
                <div className="formComponent">
                  <label>سرعت تا :‌</label>
                  <input type="number" min={0} className="form-control" id="speedMax" />
                </div>
              </div>

              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <SortTable data={this.state.sortData} sortFunction={''} url={''} params={''} pageNumber={''} />

                  {this.state.list.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{list.firstName + '  ' + list.lastName}</td>
                      <td>{list.maxSpeed.toFixed(2) + ' کیلومتر بر ساعت '}</td>
                      <td>{list.avgSpeed.toFixed(2) + ' کیلومتر بر ساعت '}</td>
                      <td>
                        <Link
                          target="_blank"
                          to={`/trajectory/${list.driverId}/${list.firstName + ' ' + list.lastName}?fromDate=${
                            this.state.fromDate
                          }&toDate=${this.state.toDate}`}
                        >
                          <img src={require('../../image/route.svg')} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default SpeedDriver
